import React, { useCallback, useMemo } from "react";

import { TagsInput } from "@/components/ui/tags-input";
import { parseBinanceSpotSymbolsInput } from "../../utils/binanceBrokerCredentials";

export interface BinanceSpotSymbolsFieldProps {
  /** Comma-separated symbols for parent state. */
  value: string;
  onChange: (value: string) => void;
  id?: string;
}

function symbolsToStorage(symbols: string[]): string {
  return symbols.join(", ");
}

const BinanceSpotSymbolsField: React.FC<BinanceSpotSymbolsFieldProps> = ({
  value,
  onChange,
  id,
}) => {
  const symbols = useMemo(() => parseBinanceSpotSymbolsInput(value), [value]);

  const handleChange = useCallback(
    (next: string[]) => {
      onChange(symbolsToStorage(next));
    },
    [onChange]
  );

  return (
    <TagsInput
      id={id}
      value={symbols}
      onChange={handleChange}
      parseTokens={parseBinanceSpotSymbolsInput}
      normalizeTag={(token) => token}
      formatDraft={(next) => next.toUpperCase()}
      placeholder="Type a pair, e.g. BTCUSDT"
      addAnotherPlaceholder="Add another pair…"
    />
  );
};

export default BinanceSpotSymbolsField;
